import React from "react";
import { ThemeIconSun } from "../../svgComponents/ThemeIconSun";

const ToggleThemeButton = ({ toggleTheme }) => {
  return (
    <button
      className="flex items-center justify-center"
      onClick={toggleTheme}
      type="button"
    >
      <ThemeIconSun width={22} height={22} color={"#fff"} />
    </button>
  );
};

export default ToggleThemeButton;
